// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__FA1pn","rotate":"spinner_rotate__k1bkA","dash":"spinner_dash__n8Eie"};